import { getCountries_countries } from './__generated__/getCountries';

export const ALL_OTHER_COUNTRIES_CODE = 'zz';

export const mapAndFilterCountries = (
  countries: getCountries_countries[],
  countryCodesToIgnore: string[],
) =>
  countries
    .filter(({ id }) => !countryCodesToIgnore.includes(id.toLowerCase()))
    .map(({ name, id }) => ({
      value: id,
      label: name,
      isDisabled: false,
    }));
